import { NavigationItem } from '@/types/global'
import { Link } from '@/Components/Navigation/Link'
import { classNames } from '@/Utils/Utils'

export function NavigationList({ items }: { items: NavigationItem[] }) {
    return (
        <>
            {items.map((item) => (
                <li key={item.name}>
                    <Link
                        href={item.href}
                        className={classNames(
                            item.current ? 'bg-stone-100 text-stone-700' : 'text-stone-600 hover:bg-stone-100 hover:text-stone-700',
                            'group flex gap-x-3 rounded-md px-2 py-3 leading-6 font-semibold tracking-wide'
                        )}
                    >
                        <item.icon
                            aria-hidden="true"
                            className={classNames(item.current ? 'text-stone-700' : 'text-stone-400 group-hover:text-stone-500', 'h-6 w-6 shrink-0')}
                        />
                        {item.name}
                    </Link>
                </li>
            ))}
        </>
    )
}

export function BottomNavigationList({ items }: { items: NavigationItem[] }) {
    return (
        <>
            {items.map((item) => {
                const As = item.asLink ? Link : 'a'
                return (
                    <li key={item.name}>
                        <As
                            href={item.href}
                            className={classNames(
                                item.current ? 'bg-stone-100 text-stone-700' : 'text-stone-600 hover:bg-stone-100 hover:text-stone-700',
                                'group flex gap-x-3 rounded-md p-1.5 text-sm leading-6 font-semibold'
                            )}
                        >
                            <item.icon
                                aria-hidden="true"
                                className={classNames(
                                    item.current ? 'text-stone-700' : 'text-stone-400 group-hover:text-stone-500',
                                    'h-6 w-6 shrink-0'
                                )}
                            />
                            {item.name}
                        </As>
                    </li>
                )
            })}
        </>
    )
}
